import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../blent-component/Icon";
import {
  ImgPropertiesSetterProps,
  GradientViewerProps,
  ImageFolderProps,
  ImageDesc,
} from "./../../types/globals.types";
import { ImageTreeControle } from "./ImageTreeControle";
import { getImageFoldersTree } from "./../..//api/global";
import { ImageFinder } from "./ImageFinder";
import styles from "./styles.module.scss";

export const ImgSetter: React.FC<
  ImgPropertiesSetterProps & GradientViewerProps
> = ({ image, setImage, closeMe }) => {
  const [imagesRoot, setImagesRoot] = useState<ImageFolderProps>();
  const [images, setImages] = useState<ImageDesc[]>();
  const { t } = useTranslation();

  useEffect(() => {
    const fechImages = async () => {
      const result = await getImageFoldersTree();
      setImagesRoot(result?.tree);
      setImages(result?.activeImages);
    };
    fechImages();
  }, []);

  const handleSelectedImg = (v: ImageDesc) => {
    setImage(v);
    closeMe();
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.closeIcon} onClick={closeMe}>
          <Icon name="ArrowLeft" size={32} />
        </div>
        <div className={styles.header}>
          <div className={styles.logo}>
            <Icon name="LogoBat" size={72} />
            {/* <img src="/logo/logo_bat_black_v1_0.png" alt="Bacardi" /> */}
          </div>
          <div className={styles.headerName}>{t("imageLibrary")}</div>
        </div>
        {imagesRoot && (
          <ImageTreeControle
            root={imagesRoot}
            onActiveImagesChange={(r, imgs) => {
              setImagesRoot(r);
              setImages(imgs);
            }}
          />
        )}
      </div>
      <div className={styles.right}>
        <ImageFinder
          images={images}
          activeImage={image}
          setActiveImg={(v: ImageDesc) => handleSelectedImg(v)}
        />
      </div>
    </div>
  );
};
